import React from 'react';
import './PanelOverlay.scss';
import { PanelComponentKeyType } from 'config/panelConfig';
import { useAnalysisPage } from '@features/analysis/useAnalysisPage';
import { usePanelContainer } from '../usePanelContainer';

interface PanelOverlayAxisProps {
  componentKey: PanelComponentKeyType;
}
const PanelOverlayAxis: React.FC<PanelOverlayAxisProps> = ({ componentKey }) => {

  const {switchConfigs} = useAnalysisPage();

  const {panelStates} = usePanelContainer();

  const {direction} = panelStates[componentKey];

  // console.log(switchConfigs,direction)
  return (
    !switchConfigs.switchAnnotation && direction && (
      <>
        <div className={`overlay-content top axis`}>
          {direction[0]}
        </div>
        <div className={`overlay-content left axis`}>
          {direction[3]}
        </div>
        <div className={`overlay-content right axis`}>
          {direction[1]}
        </div>
        <div className={`overlay-content bottom axis`}>
          {direction[2]}
        </div>
      </>
    )
  );
};

export default React.memo(PanelOverlayAxis);;
